import { render, staticRenderFns } from "./ContractEquipment.vue?vue&type=template&id=2b3d36ce"
import script from "./ContractEquipment.vue?vue&type=script&lang=js"
export * from "./ContractEquipment.vue?vue&type=script&lang=js"
import style0 from "./ContractEquipment.vue?vue&type=style&index=0&id=2b3d36ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports